<template>
  <custom-overlay class="password-overlay">
    <div class="px-5 h-full bg-white shadow-theme">
      <div class="password-wrapper" style="padding-top: 15vh">
        <div class="text-center">
          <img src="~@/assets/img/lock.png" alt="" width="88" />
          <div class="mt-6" style="margin-bottom: 48px">
            <span>输入密码进行访问</span>
          </div>
        </div>
        <div :class="{ 'pb-10': tip }" class="relative gray-input-wrapper">
          <van-field input-align="center" v-model="password" placeholder="答题密码"></van-field>
          <van-field
            input-align="center"
            v-if="passwordType === 4"
            v-model="attrValue"
            class="mt-2"
            :placeholder="passwordPropertyHint"
          ></van-field>
          <div class="absolute bottom-0 left-0 right-0">
            <span class="text-red leading-18 text-medium">
              {{ tip }}
            </span>
          </div>
        </div>
        <div class="mt-5">
          <van-button type="primary" block size="small" @click="onStart">确定</van-button>
        </div>
      </div>
    </div>
  </custom-overlay>
</template>

<script>
import CustomOverlay from '@/components/overlay/CustomOverlay'
export default {
  name: 'OverlayPassword',
  components: { CustomOverlay },
  props: {},
  data() {
    return {
      password: '',
      attrValue: '',
      tip: '',
      passwordType: 1
    }
  },
  computed: {
    passwordPropertyHint() {
      return this.$bus.survey.otherSetting?.passwordPropertyHint
    }
  },
  methods: {
    onStart() {
      if (!this.password) {
        this.tip = '密码不能为空'
        return
      }
      this.$bus.onStartAnswerByPWD(this.password, this.attrValue, () => {
        this.$emit('close')
      })
    },
    onUpdate(msg, type) {
      this.tip = msg
      if (type) {
        this.passwordType = type
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.password-overlay {
  padding: 10px;
  box-sizing: border-box;
  background-color: transparent;
}
.password-wrapper {
  padding: 0 28px;
}

.gray-input-wrapper {
  .van-field {
    @apply bg-theme-gray;
    border: none !important;
  }
}
</style>
